var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#073C50",
    fillRule: "evenodd",
    d: "M34.1766235,5.82337649 C40.972989,12.619742 41.820411,23.112307 36.7188894,30.8304124 L48.3502166,42.4617316 L42.7266668,48.0852814 L31.1009585,36.4601718 C23.3795954,41.5874661 12.865533,40.747784 6.0588745,33.9411255 C-1.70562748,26.1766235 -1.70562748,13.5878785 6.0588745,5.82337649 C13.8233765,-1.9411255 26.4121215,-1.9411255 34.1766235,5.82337649 Z M11.6824243,11.4469263 C7.02372311,16.1056275 7.02372311,23.6588745 11.6824243,28.3175757 C16.3411255,32.9762769 23.8943725,32.9762769 28.5530737,28.3175757 C33.2117749,23.6588745 33.2117749,16.1056275 28.5530737,11.4469263 C23.8943725,6.7882251 16.3411255,6.7882251 11.6824243,11.4469263 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.540b224d0d9ffa265ba039de716d61d4.svg";
export { ForwardRef as ReactComponent };